import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { fetchMyCarts, updateCart } from "../../redux/reducer/cartReducer";
import { getCurrencyAndLanguageSymbol } from "../../constent/currencyUtils";
import useLanguageDirection from "../../hooks/useLanguageDirection";

const CustomBannerShipment = ({ orderNumber,cartID,companiesChoose,getCompany,company ,loading}) => {
    const [isChecked, setIsChecked] = useState(false);
    const [selectedCompany, setSelectedCompany] = useState(null); // State for selected shipping company
    // const [select]
    const dispatch = useDispatch();
    const currencySymbol = getCurrencyAndLanguageSymbol();
    const direction = useLanguageDirection();
    
    // console.log(companiesChoose)
    const { t } = useTranslation();

      useEffect(() => {
      if (company) {
        setSelectedCompany(company);
        getCompany((prev) => ({
          ...prev,
          [cartID]: company,
        }));
      }
    }, [company, cartID, getCompany]);





    if (!companiesChoose) {
      return null; 
    }
    
      // There is another version of this function.
  const getDeliveryTime = (name) => {
    switch (name) {
      case "FedEx":
        return `3-5`;
      case "DHL":
        return `3-5`;
      case "SMSA":
        return `3-5`;
      case "AUSTRIAN POST":
        return `8-12`;
      default:
        return `3-5`;
    }
  };
  
    const handleCompanyChange = async (e) => {
      loading(true)
      const selectedCompanyName = e.target.value;

      const companyObj = companiesChoose.find(
        (company) => company?.companyName === selectedCompanyName
      );

      setSelectedCompany(companyObj);
      getCompany((prev) => ({
      ...prev,
      [cartID]: companyObj,
    })); 
     try {

        await dispatch(updateCart({
          cartId: cartID,
          data: { company: companyObj }
        })).unwrap();

        await dispatch(fetchMyCarts());
        loading(false)

      } catch (error) {
        console.error("Error updating company in cart:", error);
        loading(false)
      }
    };
    // console.log(selectedCompany)
    return (
      
      <div
        className={`flex w-full items-center justify-between lg:p-1  ${
          isChecked ? "bg-custom-yellow text-black" : "bg-white text-black"
        }`}
      >
        {/* Order Number */}
        <div className="font-bold">
        <span className="text-[10px] text-gray-800 lg:text-lg">{t("orderNumber")} :</span>
        <span className="text-[10px] text-gray-800 lg:text-base"> {orderNumber}</span>
      </div>
  
        {/* Shipping Company Dropdown */}
        <div className="flex items-center gap-2 bg-gray-300 border border-gray-500 ">
  
          {/* Dropdown */}
          <select
              value={company?.companyName || ""}
              onChange={handleCompanyChange}
              className="w-full text-xs text-black bg-white border border-gray-300 rounded lg:p-xs md:text-sm lg:text-base"
              dir={direction}
            >
              <option value="" disabled hidden className="text-xs text-black md:text-sm lg:text-base">
                {t("ChooseShippingCompany")}
              </option>
              {companiesChoose.map((company) => (
                <option className="flex justify-between w-full text-xs text-black md:text-sm lg:text-base" key={company?.companyName} value={company?.companyName} >
                  {direction === "ltr" ? 
                    <span className="text-black"> {company?.companyName} - {company.countryData.cost} {currencySymbol}  ||  (3-5) {t("Day")} </span>  
                    :
                    <>
                      <span className="text-black" dir=""> {company?.companyName} </span>
                      - <span className="text-black" dir="ltr">  {t("BusinessDay")} {getDeliveryTime(company.companyName)}  </span>  
                      || <span className="text-black" dir=""> {company.countryData.cost} {currencySymbol}</span> 
                    </>
                    
                  }
                </option>
              ))}
            </select>

        </div>
      </div>
    );
  };
  

export default CustomBannerShipment;
